var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 32,
    fill: "#0072FF",
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M27.54 20c2.217 0 3.559-1.37 3.559-3.643 0-2.266-1.342-3.63-3.537-3.63h-2.6V20h2.579zm-.063-1.317H26.5v-4.638h.98c1.364 0 2.085.696 2.085 2.312 0 1.622-.721 2.326-2.088 2.326zm6.986 1.424c1.655 0 2.685-1.133 2.685-2.813 0-1.69-1.03-2.82-2.685-2.82s-2.685 1.13-2.685 2.82c0 1.68 1.03 2.813 2.685 2.813zm.007-1.172c-.763 0-1.154-.7-1.154-1.652 0-.951.39-1.654 1.154-1.654.75 0 1.14.703 1.14 1.654 0 .952-.39 1.652-1.14 1.652zM40.466 20l.937-3.43h.068l.937 3.43h1.602l1.48-5.455h-1.526l-.831 3.644h-.047l-.894-3.644h-1.503l-.88 3.665h-.05l-.845-3.665h-1.53L38.867 20h1.598zm7.132 0v-3.153c.003-.704.422-1.115 1.033-1.115.607 0 .973.397.97 1.065V20h1.512v-3.473c0-1.271-.746-2.053-1.882-2.053-.81 0-1.396.398-1.64 1.034h-.064v-.963h-1.442V20h1.513zm6.01 0v-7.273h-1.514V20h1.513zm3.463.107c1.655 0 2.684-1.133 2.684-2.813 0-1.69-1.03-2.82-2.684-2.82-1.655 0-2.685 1.13-2.685 2.82 0 1.68 1.03 2.813 2.685 2.813zm.007-1.172c-.764 0-1.154-.7-1.154-1.652 0-.951.39-1.654 1.154-1.654.75 0 1.14.703 1.14 1.654 0 .952-.39 1.652-1.14 1.652zm5.012 1.168c.806 0 1.328-.352 1.594-.86h.043V20h1.434v-3.679c0-1.3-1.1-1.847-2.315-1.847-1.307 0-2.166.625-2.376 1.62l1.4.113c.103-.362.426-.628.969-.628.515 0 .81.26.81.707v.02c0 .352-.373.399-1.321.49-1.08.1-2.05.463-2.05 1.68 0 1.08.771 1.627 1.812 1.627zm.433-1.044c-.465 0-.799-.217-.799-.632 0-.426.352-.636.884-.71.33-.047.87-.125 1.051-.245v.578c0 .572-.472 1.009-1.136 1.009zm5.615 1.03c.881 0 1.34-.508 1.549-.963h.064V20h1.491v-7.273h-1.509v2.735h-.046c-.203-.444-.64-.988-1.552-.988-1.197 0-2.209.93-2.209 2.806 0 1.825.97 2.809 2.212 2.809zm.48-1.204c-.742 0-1.147-.66-1.147-1.612 0-.945.398-1.595 1.147-1.595.735 0 1.147.622 1.147 1.595s-.42 1.612-1.147 1.612z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.29 11.29c-.19.188-.296.443-.296.71 0 .267.107.522.296.71l3 3c.188.19.443.296.71.296.267 0 .522-.107.71-.296l3-3c.392-.392.392-1.028 0-1.42-.392-.392-1.028-.392-1.42 0L10 12.59V1c0-.552-.448-1-1-1S8 .448 8 1v11.59l-1.29-1.3c-.188-.19-.443-.296-.71-.296-.267 0-.522.107-.71.296zM15 7h-2c-.552 0-1 .448-1 1s.448 1 1 1h2c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h2c.552 0 1-.448 1-1s-.448-1-1-1H3c-1.657 0-3 1.343-3 3v7c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3v-7c0-1.657-1.343-3-3-3z",
    transform: "translate(48 36) translate(7 6)"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 8,
    x: 14,
    y: 88,
    fill: "#338EFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 8,
    x: 14,
    y: 104,
    fill: "#99C7FF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 8,
    x: 14,
    y: 120,
    fill: "#99C7FF",
    rx: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesDownload);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-download.4bce8e3b.svg";
export { ForwardRef as ReactComponent };